// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"411":"a2d895ca","447":"3e9cfbf9","488":"9b75119f"}[chunkId] + ".chunk.js";
};